import {ImageResizeOptions, WowImage} from 'wix-ui-tpa/cssVars'
import React from 'react'
import {hasImage} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import {resolveFocalPoint} from '../../../../../commons/utils/image'
import s from './event-image.scss'
import {classes} from './event-image.st.css'
import {EventImageProps} from './interfaces'

export const EventImage = ({
  event,
  position,
  fitImage,
  className,
  singleLayout,
  noBackground,
  backgroundFallback,
  opacityFallback,
  noLQIP,
}: EventImageProps) => {
  const focalPoint = resolveFocalPoint(position)

  const getOpacityClass = () => {
    if (singleLayout && opacityFallback) {
      return classes.singleOpacity
    } else {
      if (opacityFallback) {
        return classes.multiOpacityWithFallback
      } else {
        return classes.multiOpacity
      }
    }
  }

  const getBackgroundClass = () => {
    if (singleLayout) {
      return s.singleBackground
    } else if (backgroundFallback) {
      return s.multiBackgroundWithFallback
    } else {
      return s.multiBackground
    }
  }

  return (
    <>
      {!noBackground ? (
        <div className={classNames(s.container, getBackgroundClass())} data-hook="image-background" />
      ) : null}
      {hasImage(event) ? (
        <div className={classNames(s.container, className)}>
          <WowImage
            data-hook={DH.image}
            className={classNames(s.imageSizing, getOpacityClass())}
            src={event.mainImage?.id}
            alt={event.title}
            sourceWidth={event.mainImage.width}
            sourceHeight={event.mainImage.height}
            focalPoint={focalPoint}
            resize={fitImage ? ImageResizeOptions.contain : ImageResizeOptions.cover}
            shouldUseLQIP={!noLQIP}
            fluid
          />
        </div>
      ) : null}
    </>
  )
}
